import { useState } from "react";
import { FormFull } from "form-full";

import { StylesForm, StylesGuest } from "../../../styles";
import { customModal } from "../../../../../components/modals/utils";
import { CompanionForm } from "./CompanionForm";

interface IDrawExtra {
  data: any;
  fileName: any;
  fileInputRef: any;
  handleImageChange: (index?: number) => void;
  openModalViewImg: (data: { name: string; src: string }) => void;
  fileRef: any;
  setFileName: any;
  setStep: any;
  onSubmit: any;
  extraData: any;
  size: number;
}

export function DrawExtra({
  data,
  fileName,
  fileInputRef,
  handleImageChange,
  openModalViewImg,
  fileRef,
  setFileName,
  setStep,
  onSubmit,
  extraData,
  size
}: IDrawExtra) {
  const [underAgeStatus, setUnderAgeStatus] = useState(Array(size).fill(false));

  const updateIsUnderAge = (index, isUnderAge) => {
    const updatedStatus = [...underAgeStatus];
    updatedStatus[index] = isUnderAge;
    setUnderAgeStatus(updatedStatus);
  };

  console.log("data", data);

  const confirmAllImages = (files) => {
    let all = 0;
    for (let index = 0; index < size; index++) {
      if (
        !underAgeStatus[index] &&
        files.hasOwnProperty(`other-${index}`) &&
        files[`other-${index}`]
      ) {
        all += 1;
      }
    }
    return false;
    // return all !== size;
  };

  return (
    <FormFull
      onSubmit={(data) => {
        onSubmit({ ...extraData, ...data });
      }}
    >
      {Array.from({ length: size }).map((_, index) => {
        const companion = data?.secondaryGuests[index];
        return (
          <CompanionForm
            companion={companion}
            fileName={fileName}
            index={index}
            key={index}
            handleImageChange={handleImageChange}
            openModalViewImg={openModalViewImg}
            fileRef={fileRef}
            updateIsUnderAge={updateIsUnderAge}
          />
        );
      })}

      <StylesGuest.ButtonsContainer>
        {" "}
        <StylesForm.Clear
          fullWidth={false}
          action="clearDefault"
          onClick={() => {
            if (fileInputRef?.current?.value) {
              fileInputRef.current.value = "";
            }
            let imagesList = fileRef.current;
            let names = { ...fileName };
            for (let index = 0; index < size; index++) {
              if (
                !data?.secondaryGuests.find((i) => i.image !== null) &&
                imagesList.hasOwnProperty(`other-${index}`) &&
                names.hasOwnProperty(`other-${index}`)
              ) {
                delete imagesList[`other-${index}`];
                delete names[`other-${index}`];
              }
            }

            fileRef.current = { ...imagesList, base: fileRef.current.base };
            setFileName({ ...names, base: fileName.base });
          }}
        >
          Limpar Campos
        </StylesForm.Clear>
        <StylesForm.Back
          fullWidth={false}
          action="clear"
          onClick={() => {
            customModal.setInfos(
              "Voltar",
              [
                "Atenção, ao voltar os dados dos hóspedes acompanhantes não serão salvos. Deseja confirmar e voltar?"
              ],
              {
                onClick: () => {
                  customModal.close();
                  setStep(1);
                  fileRef.current = { base: fileRef.current.base };
                  setFileName({ base: fileName.base });
                },
                label: "Sim, Voltar"
              },
              {
                onClick: () => {
                  customModal.close();
                },
                label: "Cancelar"
              }
            );
          }}
        >
          Voltar
        </StylesForm.Back>
        <StylesForm.SendForm
          disabled={confirmAllImages(fileName)}
          fullWidth={false}
          action="submit"
        >
          Confirmar dados
        </StylesForm.SendForm>
      </StylesGuest.ButtonsContainer>
    </FormFull>
  );
}
